export default __webpack_public_path__ + "static/media/team102.0ae9a862.JPG";